
export const formacionUno = [
    {
        top: '16.25%',
        left: '25%'
    },
    {
        top: '33.25%',
        left: '20%'
    },
    {
        top: '58.75%',
        left: '20%'
    },
    {
        top: '75.75%',
        left: '25%'
    },
    {
        top: '33.25%',
        left: '40%'
    },
    {
        top: '58.75%',
        left: '40%'
    },
    {
        top: '20.5%',
        left: '50%'
    },

    {
        top: '71.5%',
        left: '50%'
    },
    {
        top: '58.75%',
        left: '70%'
    },
    {
        top: '33.25%',
        left: '75%'
    }
];

export const formacionDos = [
    {
        top: '16.25%',
        left: '25%'
    },
    {
        top: '33.25%',
        left: '20%'
    },
    {
        top: '58.75%',
        left: '20%'
    },
    {
        top: '75.75%',
        left: '25%'
    },
    {
        top: '46%',
        left: '35%'
    },
    {
        top: '24.75%',
        left: '45%'
    },
    {
        top: '67.25%',
        left: '45%'
    },
    {
        top: '46%',
        left: '60%'
    },
    {
        top: '33.25%',
        left: '75%'
    },
    {
        top: '58.75%',
        left: '75%'
    },
];

export const formacionTres = [
    {
        top: '16.25%',
        left: '25%'
    },
    {
        top: '33.25%',
        left: '20%'
    },
    {
        top: '58.75%',
        left: '20%'
    },
    {
        top: '75.75%',
        left: '25%'
    },
    {
        top: '33.25%',
        left: '40%'
    },
    {
        top: '58.75%',
        left: '40%'
    },
    {
        top: '20.5%',
        left: '60%'
    },
    {
        top: '46%',
        left: '60%'
    },
    {
        top: '71.5%',
        left: '60%'
    },
    {
        top: '46%',
        left: '75%'
    },
];

export const formacionCuatro = [
    {
        top: '16.25%',
        left: '25%'
    },
    {
        top: '33.25%',
        left: '20%'
    },
    {
        top: '58.75%',
        left: '20%'
    },
    {
        top: '75.75%',
        left: '25%'
    },
    {
        top: '46%',
        left: '40%'
    },
    {
        top: '24.75%',
        left: '50%'
    },
    {
        top: '67.25%',
        left: '50%'
    },
    {
        top: '16.25%',
        left: '70%'
    },
    {
        top: '75.75%',
        left: '70%'
    },
    {
        top: '46%',
        left: '75%'
    },
];

export const formacionCinco = [
    {
        top: '20.5%',
        left: '25%'
    },
    {
        top: '46%',
        left: '20%'
    },
    {
        top: '71.5%',
        left: '25%'
    },
    {
        top: '33.25%',
        left: '40%'
    },
    {
        top: '58.75%',
        left: '40%'
    },
    {
        top: '16.25%',
        left: '50%'
    },
    {
        top: '75.75%',
        left: '50%'
    },
    {
        top: '24.75%',
        left: '70%'
    },
    {
        top: '67.25%',
        left: '70%'
    },
    {
        top: '46%',
        left: '80%'
    },
];

export const formacionSeis = [
    {
        top: '20.5%',
        left: '25%'
    },
    {
        top: '46%',
        left: '20%'
    },
    {
        top: '71.5%',
        left: '25%'
    },
    {
        top: '46%',
        left: '40%'
    },
    {
        top: '12%',
        left: '50%'
    },
    {
        top: '29%',
        left: '45%'
    },
    {
        top: '63%',
        left: '45%'
    },
    {
        top: '80%',
        left: '50%'
    },
    {
        top: '33.25%',
        left: '75%'
    },
    {
        top: '58.75%',
        left: '75%'
    },
];

export const formacionSiete = [
    {
        top: '20.5%',
        left: '25%'
    },
    {
        top: '46%',
        left: '20%'
    },
    {
        top: '71.5%',
        left: '25%'
    },
    {
        top: '46%',
        left: '40%'
    },
    {
        top: '24.75%',
        left: '50%'
    },
    {
        top: '67.25%',
        left: '50%'
    },
    {
        top: '46%',
        left: '65%'
    },
    {
        top: '12%',
        left: '75%'
    },
    {
        top: '80%',
        left: '75%'
    },
    {
        top: '46%',
        left: '80%'
    },
];

export const formacionOcho = [
    {
        top: '12%',
        left: '30%'
    },
    {
        top: '29%',
        left: '25%'
    },
    {
        top: '46%',
        left: '20%'
    },
    {
        top: '63%',
        left: '25%'
    },
    {
        top: '80%',
        left: '30%'
    },
    {
        top: '33.25%',
        left: '45%'
    },
    {
        top: '58.75%',
        left: '45%'
    },
    {
        top: '16.25%',
        left: '55%'
    },
    {
        top: '75.75%',
        left: '55%'
    },
    {
        top: '46%',
        left: '70%'
    },
];